import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface SoldStatusDTO extends BaseIntDTO {
  soldStatusName: string;
}
